import React from 'react'
import { NavMobile } from './NavMobile'
import { NavDesktop } from './NavDesktop'

const Navbar = () => {
  return (
    <header className='relative z-100 flex flex-col items-center bg-white-menu shadow-md'>
      <NavDesktop className='hidden lg:flex max-w-screen-xl w-4/5 py-7 items-center text-090909' />
      <NavMobile className='lg:hidden w-full' />
    </header>
  )
}
export default Navbar
